import articlesImg from './../../../assets/images/article-search.svg';
import sourceSheetImg from './../../../assets/images/source-sheet-search.svg';
import eventsImg from './../../../assets/images/events-search.svg';
import classesImg from './../../../assets/images/classes-search.svg';
import './SearchSideBar.scss';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { ResultTypeAmount } from '../../../store/reducers/mainReducer';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setSearchFilter } from '../../../store/actions/mainActions';
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";

export const SearchSideBar = (props: any) => {

    const { resultTypeAmount } = useSelector((state: any) => state.main);
    const [typeResults, setTypeResults] = useState<any[]>([])
    const dispatch = useDispatch()

    const getAmountOfTypes = useCallback(() => {

        const initialTypeResults = [
            {
                type: "Articles",
                amount: 0,
                icon: <img src={articlesImg} alt=""></img>,
                originalType: '',
            },
            {
                type: "Source Sheets",
                amount: 0,
                icon: <img src={sourceSheetImg} alt=""></img>,
                originalType: '',
            },
            {
                type: "Events",
                amount: 0,
                icon: <img src={eventsImg} alt=""></img>,
                originalType: '',
            },
            {
                type: "Classes",
                amount: 0,
                icon: <img src={classesImg} alt=""></img>,
                originalType: '',
            },
            // {
            //     type: "Friends",
            //     amount: 0,
            //     icon: <img src={friendsImg} alt=""></img>,
            //     originalType: '',
            // },
            // {
            //     type: "Communities",
            //     amount: 0,
            //     icon: <img src={communitiesImg} alt=""></img>,
            //     originalType: '',
            // }

        ]
        const newTypeResults: any[] = []

        resultTypeAmount.map((r: ResultTypeAmount, i: number) => {
            initialTypeResults[i].amount = r.amount;
            initialTypeResults[i].originalType = r.originalType;
            newTypeResults.push({ ...initialTypeResults[i] });
            return r;
        })
        setTypeResults(newTypeResults)
    }, [resultTypeAmount])

    useEffect(() => {
        getAmountOfTypes()
    }, [getAmountOfTypes, resultTypeAmount])


    const filter = (type: string) => {

        if (type)
            dispatch(setSearchFilter(type))
    }

    return (
      <div className="container">
        <div className="row">
          <h4 className="search-sidebar-title">Search Results</h4>
          {typeResults.map((t, i) => (
            <div key={i} onClick={() => filter(t.originalType)} className=" col-12 d-flex mt-4 align-items-center search-type-color p-0">
              <div className="search-i-wrapper">{t.icon}</div>
              <div className="pointer mx-2">{t.type}</div>
              <div className="pointer">({t.amount})</div>
            </div>
          ))}

          <div onClick={() => filter("reset")} className="col-12 d-flex mt-4 align-items-center search-type-color p-0">
            <div className="search-i-wrapper">
              <FilterAltOffIcon sx={{ stroke: "#000", strokeWidth: 0.75 }} />
            </div>
            <div className="pointer mx-2">Cancel Filter</div>
          </div>
        </div>
      </div>
    );
}